import { ReactNode } from "react";
import { UseFormRegister } from "react-hook-form";
import styles from "../Form.module.css";

const SelectField: React.FC<{
  label?: string | number;
  name: string;
  id?: string;
  error?: string;
  children: ReactNode;
  customClassName?: string;
  defaultValue?: string | number;
  register: UseFormRegister<any>;
}> = (props) => (
  <div className={`${props.customClassName}`}>
    <label
      className={`leading-7 block text-sm text-neutralColor-medium`}
      htmlFor={props.name}
    >
      {props.label}
    </label>
    <select
      className={`${
        props.error ? styles["form-select-error"] : styles["form-select-normal"]
      }`}
      id={props.id}
      defaultValue="select"
      {...props.register(props.name)}
    >
      {props.children}
    </select>
    {props.error && <p className="text-red-600 text-sm mt-2">{props.error}</p>}
  </div>
);

export default SelectField;
